/**
 * Validates if a given URL is a valid LinkedIn profile URL
 * @param url - The URL to validate
 * @returns true if the URL is a valid LinkedIn profile URL
 */
export function isValidLinkedinUrl(url: string): boolean {
  const regex = /^https?:\/\/(([\w]{2,3}\.)?linkedin\.com)\/(pub|in|profile)\/[^\s/?#&]+\/?(?:[^\s]*)?$/i;
  return regex.test(url);
}

/**
 * Enhances a LinkedIn URL with a recommender message
 * @param linkedinUrl - The LinkedIn profile URL
 * @returns Enhanced message for the recommender
 */
export function createLinkedInRecommenderMessage(linkedinUrl: string): string {
  return `Por favor recomendame cursos para mi perfil de Linkedin: ${linkedinUrl}`;
}

